const PizzaData = [
  {
    productname: "SPINACH CORN PIZZA",
    productdescription:
      "Exotic combination of spinach and corn pizzaPacked with sauteed spinach, gooey cashew cheese on a classic wheat pizza topped with a generous helping of sizzling pizza masala.",
  },
  {
    productname: "FARM HOUSE PIZZA",
    productdescription:
      "Pizza base topped with the choicest seasonal vegetables .Loaded with black olives, jalapeno, capsicum, baby corn along with cashew cheese",
  },
  {
    productname: "MUSHROOM CORN PIZZA",
    productdescription:
      "A delightful combination of mushroom, jalapeno, baby corn filled with delicious cashew cheese.",
  },
];
export default PizzaData;
